module.exports = __webpack_public_path__ + "0af5d249/img/cadBim.e369a02a.png";